<template>
  <div class="fair-survey-step fair-survey-step--welcome">
    <div class="fair-survey-step__head">
      <span class="fair-survey-step__eyebrow">Мой стиль</span>
      <h1 class="fair-survey-step__title fair-survey-step__title--hero">
        {{ step.title }}
      </h1>
      <p
        v-if="step.subtitle"
        class="fair-survey-step__subtitle"
      >
        {{ step.subtitle }}
      </p>
    </div>

    <ul class="fair-survey-step__facts">
      <li
        v-for="fact in FACTS"
        :key="fact"
        class="fair-survey-step__fact"
      >
        {{ fact }}
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
/**
 * Opening screen of the taste survey.
 *
 * The AI avatar is gone for the same reason as in the size survey: it said
 * nothing and pushed the copy below the fold. What earns the space is what the
 * survey asks for and what it changes afterwards.
 */
import type { TasteStep } from '@/features/taste/types/taste-config'

defineProps<{ step: TasteStep & { type: 'welcome' } }>()

const FACTS = [
  'Выберите любимые бренды, стили и цвета',
  'Оцените несколько образов — как в ленте',
  'Подборки и рекомендации подстроятся под вас',
]
</script>

<style scoped>
.fair-survey-step--welcome {
  justify-content: center;
  gap: var(--fair-rd-space-40);
  padding-block: var(--space-32);
}

.fair-survey-step__title--hero {
  font-size: 44px;
  line-height: 1.05;
}

:global(.fair-survey-dialog--compact) .fair-survey-step__title--hero {
  font-size: 28px;
}

.fair-survey-step__facts {
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
  margin: 0;
  padding: 0;
  list-style: none;
}

.fair-survey-step__fact {
  padding-block: var(--space-12);
  border-top: 1px solid var(--color-line-hairline);
  font-family: var(--fair-font-body, Inter, sans-serif);
  font-size: 15px;
  line-height: 1.3;
  color: var(--color-text-secondary);
}

.fair-survey-step__fact:last-child {
  border-bottom: 1px solid var(--color-line-hairline);
}
</style>
